import React from 'react';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { RouteDetails } from '../../common/route-details/RouteDetails';
import { isEqual } from 'lodash';
import { initialJoinCommuteState } from '../../JoinCommuteReducer';
import DisplayCard from '../display-card/DisplayCard';
import Tick from '../../../_styles/images/tick.svg';
import { getDayString, getFullPrice, getNextMonth, getExpiryFromObject } from '../../helpers/vanHelpers';
import Loading from '../../../shared/loading/Loading';
import { GET_PRORATED_AMOUNT, SAVE_SUBSCRIPTION_SUMMARY, SAVE_COMMUTE_PROFILE, APPLY_TO_SIGN_CONTRACT } from '../../../redux/actionTypes';
import { Link } from 'react-router-dom';
import ArrowLeft from '../../../_styles/images/ArrowLeft.png';
import InfoCircle from '../../../_styles/images/new-icons/driver-status/info_circle.svg';
import { assignPriceToCards } from '../../../shared/helpers/cardHelpers';
import { numberWithCommas, getPlan } from '../../helpers/commonHelper';
import ImageNotAvailable from '../../../_styles/images/ImageNotAvailable.svg';
import analyticsService from '../../../shared/analytics/analytics-service';
import PriceDisclaimerPopup from '../../subscription/PriceDisclaimerPopup';
import Callable from '../../../shared/Callable';
import TaxesAccordion from '../../../payment/common/TaxesAccordion';
import RateAccordion from '../../../payment/common/RateAccordion';
import dateUtility from '../../../shared/dateUtility';
import { getDateObjFromString } from '../../../payment-history/helper';
import SponsoredVanpool from '../../helpers/sponsoredVanpool';
import PaymentCard from '../../../payment/common/paymentCard';
import ImageNotAvailableNoCross from '../../../_styles/images/Img_not_available_no_cross.png';


function FinalSummary(props) {

    const [selectedVan, updateSelectedvan] = useState({});
    const [vanCharge, updateVanCharge] = useState();
    const [isDriver, updateIsDriver] = useState(false);
    const [rideDays, updateRideDays] = useState([]);
    const [selectedDay, updateSelectedDay] = useState();
    const [selectedDayString, updateSelectedDayString] = useState();
    const [buttonDisabled, updateButtonDisabled] = useState(true);
    const [cards, updateCards] = useState([]);
    const [checkBox, updateCheckBox] = useState(false);
    const [proratedAmount, updateProratedAmount] = useState(0);
    const [recurringChargeDate, updateRecurringChargeDate] = useState();
    const [showPDPopup, updatePDPopup] = useState(false);
    const [loading, updateLoading] = useState(false);
    const [nextMonthProratedDetail, updateNextMonthProratedDetail] = useState(null);
    const [currentMonthProratedDetail, updateCurrentMonthProratedDetail] = useState(null);
    const [currentTotalAmount, updateCurrentTotalAmount] = useState(null);
    const [nextTotalAmount, updateNextTotalAmount] = useState(null);
    // const [nextSurchargesTaxes, updateNextSurchargesTaxes] = useState(null);
    // const [currentSurchargesTaxes, updateCurrentSurchargesTaxes] = useState(null);
    const [showNextMonth, updateShowNextMonth] = useState(false);
    const [showCurrentMonth, updateShowCurrentMonth] = useState(false);

    useEffect(() => {
        if (isEqual(props.joinCommuteData, initialJoinCommuteState)) {
            props.history.push("/JoinCommute");
        }
        analyticsService.pageInfo("add payment");
    }, [])

    useEffect(() => {
        if (props.joinCommuteData) {
            if (props.joinCommuteData.selectedVan) {
                updateSelectedvan(props.joinCommuteData.selectedVan);
                var rosterDays = props.joinCommuteData.userCommuteData.rosterDays;
                var ridedays = Object.keys(rosterDays).filter((d) => rosterDays[d]);
                updateRideDays(ridedays)
            }
            if (props.joinCommuteData.userCommuteData) {
                if (props.joinCommuteData.userCommuteData.startDate) {
                    const convertedDate = new Date(props.joinCommuteData.userCommuteData.startDate);
                    updateSelectedDay(convertedDate);
                    updateSelectedDayString(props.joinCommuteData.userCommuteData.startDateString);
                }
                if(props.joinCommuteData.userCommuteData.changeStartDate) {
                    updateSelectedDay(props.joinCommuteData.userCommuteData.changeStartDate);
                    updateSelectedDayString(props.joinCommuteData.userCommuteData.changeStartDateString);
                }
                if (props.joinCommuteData.userCommuteData.proratedAmount) {
                    const amount = parseFloat(props.joinCommuteData.userCommuteData.proratedAmount);
                    const fullAmount = getFullPrice(amount);
                    updateProratedAmount(fullAmount);
                }
                if (props.joinCommuteData.userCommuteData.recurringPaymentStartDate) {
                    const chargeDateObj = getDateObjFromString(props.joinCommuteData.userCommuteData.recurringPaymentStartDate);
                    updateRecurringChargeDate(chargeDateObj);
                }
            }
            if (props.joinCommuteData.drivingScheduleData) {
                if (props.joinCommuteData.drivingScheduleData.isDesiredDriverRole) {
                    updateIsDriver(true);
                } else {
                    updateIsDriver(false);
                }
            }
            if (props.summaryData) {
                const summaryTotal = getFullPrice(props.summaryData.totalAmount);
                updateVanCharge({ ...summaryTotal, rate: props.summaryData.subscriptionRate });
                if (props.summaryData.nextMonthProratedDetail) {
                    var nAmount = parseFloat(props.summaryData.nextMonthProratedDetail.proratedAmount);
                    const nextTotal = getFullPrice(nAmount);
                    updateNextTotalAmount({ ...nextTotal, rate: props.summaryData.nextMonthProratedDetail.proratedRate })
                    updateNextMonthProratedDetail(props.summaryData.nextMonthProratedDetail);
                    if (props.summaryData.nextMonthProratedDetail.paymentDetail && props.summaryData.nextMonthProratedDetail.paymentDetail.length > 0) {
                        if (props.joinCommuteData.payment.cards && props.joinCommuteData.payment.cards.length > 0) {
                            props.summaryData.nextMonthProratedDetail.paymentDetail.forEach((card, i) => {
                                if (card.isFederalBenefitCard) {
                                    const nmatch = props.joinCommuteData.payment.cards.find(pCard => (pCard.isFederal && pCard.isDefault));
                                    if (nmatch && nmatch.cardNumber) {
                                        props.summaryData.nextMonthProratedDetail.paymentDetail[i].partialAccountNumber = String(nmatch.cardNumber).slice(-4);
                                        props.summaryData.nextMonthProratedDetail.paymentDetail[i].cardBrand = nmatch.cardType && nmatch.cardType.type;
                                    }
                                } else if(card.isCommuterBenefitCard) {
                                    const cbmatch = props.joinCommuteData.payment.cards.find(pCard => (pCard.isCommuter && pCard.isDefault));
                                    if (cbmatch && cbmatch.cardNumber) {
                                        props.summaryData.nextMonthProratedDetail.paymentDetail[i].partialAccountNumber = String(cbmatch.cardNumber).slice(-4);
                                        props.summaryData.nextMonthProratedDetail.paymentDetail[i].cardBrand = cbmatch.cardType && cbmatch.cardType.type;
                                    }
                                } 
                                else {
                                    const nfmatch = props.joinCommuteData.payment.cards.find(pCard => !pCard.isFederal && !pCard.isCommuter && (pCard.isDefault || pCard.isBackup));
                                    if (nfmatch && nfmatch.cardNumber) {
                                        props.summaryData.nextMonthProratedDetail.paymentDetail[i].partialAccountNumber = String(nfmatch.cardNumber).slice(-4);
                                        props.summaryData.nextMonthProratedDetail.paymentDetail[i].isDefault = nfmatch.isDefault;
                                        props.summaryData.nextMonthProratedDetail.paymentDetail[i].isBackup = nfmatch.isBackup;
                                        props.summaryData.nextMonthProratedDetail.paymentDetail[i].cardBrand = nfmatch.cardType && nfmatch.cardType.type;
                                        const nExp = getExpiryFromObject(nfmatch.expiry, true);
                                        props.summaryData.nextMonthProratedDetail.paymentDetail[i].expirationMMYY = nExp;
                                    }
                                }
                            });
                        }
                    }
                    updateShowNextMonth(true)
                }
                if (props.summaryData.currentMonthProratedDetail) {
                    var cAmount = parseFloat(props.summaryData.currentMonthProratedDetail.proratedAmount);
                    const currentTotal = getFullPrice(cAmount);
                    updateCurrentTotalAmount({ ...currentTotal, rate: props.summaryData.currentMonthProratedDetail.proratedRate })
                    updateCurrentMonthProratedDetail(props.summaryData.currentMonthProratedDetail);
                    if (props.summaryData.currentMonthProratedDetail.paymentDetail && props.summaryData.currentMonthProratedDetail.paymentDetail.length > 0) {
                        if (props.joinCommuteData.payment.cards && props.joinCommuteData.payment.cards.length > 0) {
                            props.summaryData.currentMonthProratedDetail.paymentDetail.forEach((card, i) => {
                                if (card.isFederalBenefitCard) {
                                    const cmatch = props.joinCommuteData.payment.cards.find(pCard => (pCard.isFederal && pCard.isDefault));
                                    if (cmatch && cmatch.cardNumber) {
                                        props.summaryData.currentMonthProratedDetail.paymentDetail[i].partialAccountNumber = String(cmatch.cardNumber).slice(-4);
                                        props.summaryData.currentMonthProratedDetail.paymentDetail[i].cardBrand = cmatch.cardType && cmatch.cardType.type;
                                    }
                                } else if(card.isCommuterBenefitCard) {
                                    const cmmatch = props.joinCommuteData.payment.cards.find(pCard => (pCard.isCommuter && pCard.isDefault));
                                    if (cmmatch && cmmatch.cardNumber) {
                                        props.summaryData.currentMonthProratedDetail.paymentDetail[i].partialAccountNumber = String(cmmatch.cardNumber).slice(-4);
                                        props.summaryData.currentMonthProratedDetail.paymentDetail[i].cardBrand = cmmatch.cardType && cmmatch.cardType.type;
                                    }
                                } 
                                else {
                                    const cfmatch = props.joinCommuteData.payment.cards.find(pCard => !pCard.isFederal && !pCard.isCommuter && (pCard.isDefault || pCard.isBackup));
                                    if (cfmatch && cfmatch.cardNumber) {
                                        props.summaryData.currentMonthProratedDetail.paymentDetail[i].partialAccountNumber = String(cfmatch.cardNumber).slice(-4);
                                        props.summaryData.currentMonthProratedDetail.paymentDetail[i].isDefault = cfmatch.isDefault;
                                        props.summaryData.currentMonthProratedDetail.paymentDetail[i].isBackup = cfmatch.isBackup; 
                                        props.summaryData.currentMonthProratedDetail.paymentDetail[i].cardBrand = cfmatch.cardType && cfmatch.cardType.type;
                                        const cExp = getExpiryFromObject(cfmatch.expiry, true);
                                        props.summaryData.currentMonthProratedDetail.paymentDetail[i].expirationMMYY = cExp;
                                    }
                                }
                            });
                        }
                    }
                    updateShowCurrentMonth(true)
                }
            }
        }
        analyticsService.pageInfo("add payment");
    }, [props.joinCommuteData, props.summaryData]);

    useEffect(() => {
        if (!props.isCardLoading) {
            if (vanCharge && vanCharge.totalAmount !== undefined && props.joinCommuteData && props.joinCommuteData.payment && props.joinCommuteData.payment.cards && props.joinCommuteData.payment.cards.length > 0) {
                var fromFS = true;
                const tempCards = assignPriceToCards(vanCharge.totalAmount, props.joinCommuteData.payment.cards, fromFS);
                updateCards(tempCards);
            }
        }
    }, [props.isChangedPlan, vanCharge, props.joinCommuteData, props.joinCommuteData.payment.cards, props.isCardLoading])

    useEffect(() => {
        if (checkBox) {
            updateButtonDisabled(false);
        } else {
            updateButtonDisabled(true);
        }
    }, [checkBox])

    function onContinue() {
        analyticsService.analyticsProcessEvent({
            "event": "payment_summary_click_continue",
            "context": {
                "event_action": "finish"
            }
        });
        props.saveSummary(selectedDayString ? selectedDayString : null, props.history);
    }

    function toggleCheckBox() {
        updateCheckBox(!checkBox);
    }

    function onCheckKeyDown(e) {
        if (e.which === 13) {
            toggleCheckBox();
        }
    }

    useEffect(() => {
        if (props.isCardLoading || props.isLoadingProratedAmount || props.isSaving) {
            updateLoading(true);
        } else {
            updateLoading(false);
        }
    }, [props.isCardLoading, props.isLoadingProratedAmount, props.isSaving])

    function getTaxesSurchargesTotal(taxes, surcharges) {
        var  surchargesAmount = surcharges && surcharges.length ? surcharges.reduce((sum, charge) => sum + charge.amount, 0): 0;
        var taxesAmount = taxes && taxes.length ? taxes.reduce((sum, charge) => sum + charge.amount, 0) : 0;
        var total = parseFloat(taxesAmount) + parseFloat(surchargesAmount);
        return total
    }

    function getPaymentCards(){
        var currentCards =  currentMonthProratedDetail && currentMonthProratedDetail.paymentDetail && currentMonthProratedDetail.paymentDetail.length && currentMonthProratedDetail.paymentDetail;
        var nextCards = nextMonthProratedDetail && nextMonthProratedDetail.paymentDetail && nextMonthProratedDetail.paymentDetail.length && nextMonthProratedDetail.paymentDetail;
        let result = [];
        // for Federal
        const isFederal1 = currentCards && currentCards.length && currentCards.find(item => item.isFederalBenefitCard);
        const isFederal2 = nextCards && nextCards.length && nextCards.find(item => item.isFederalBenefitCard);
        if (isFederal1 && isFederal2) {
            result.push({
              ...isFederal1,
              amount: (parseFloat(isFederal1.amount) + parseFloat(isFederal2.amount)).toFixed(2)
            });
        } else if(isFederal1){
            result.push({  ...isFederal1})
        } else if(isFederal2){
            result.push({  ...isFederal2})
        }

        // for Commuter
        const isCommuter1 = currentCards && currentCards.length && currentCards.find(item => item.isCommuterBenefitCard);
        const isCommuter2 = nextCards && nextCards.length && nextCards.find(item => item.isCommuterBenefitCard);
        if (isCommuter1 && isCommuter2) {
            result.push({
              ...isCommuter1,
              amount: (parseFloat(isCommuter1.amount) + parseFloat(isCommuter1.amount)).toFixed(2)
            });
        } else if(isCommuter1){
            result.push({  ...isCommuter1})
        } else if(isCommuter2){
            result.push({  ...isCommuter2})
        }

        // for retails
        const isRetail1 = currentCards && currentCards.length && currentCards.find(item => !( item.isFederalBenefitCard || item.isCommuterBenefitCard ));
        const isRetail2 = nextCards && nextCards.length && nextCards.find(item => !( item.isFederalBenefitCard || item.isCommuterBenefitCard ));
        if (isRetail1 && isRetail2) {
            result.push({
              ...isRetail1,
              amount: (parseFloat(isRetail1.amount) + parseFloat(isRetail2.amount)).toFixed(2)
            });
        } else if(isRetail1){
            result.push({  ...isRetail1})
        } else if(isRetail2){
            result.push({  ...isRetail2})
        }
        if(result && result.length){
            return result.map(card => <PaymentCard key={card.cardNumber} card={card} fromFS={true} />)
        }
    }

    return (
        <div className='new-final-summary-container'>
            <Loading isLoading={loading} />
            <div className="new-final-summary-page">
                <div className='header'>
                    <div className='backArrow'>
                        <Link className="overview-link" onClick={props.history.goBack}>
                            <img alt='go back' src={ArrowLeft}></img>
                        </Link>
                    </div>
                    <div className='heading'>Payment Summary</div>
                </div>
                {props.isChangedPlan &&
                    <div className='blue-notes' role='alert'>
                        <div className='warning-icon'>
                            <img className='info-circle' alt='information-icon' src={InfoCircle} aria-hidden='true' />
                        </div>
                        We’ve changed your plan to become a rider as you don’t currently qualify as a driver. Please check your new rates below.
                    </div>}
                <div className="new-vanpool-summary">
                    <div className='left-column'>
                        <div className="new-vanpool-summary-details">
                            <div className="vanpool-Details">
                                {
                                    <div className='van-details-mobile mobile'> 
                                     <div className='van-image-details'> 
                                     <div className="van-Image">
                                            <div className={`${selectedVan.isPredelivery ? 'car-image-opacity' : 'car-image'}`}>
                                                <img src={selectedVan.carClassImage} onError={e => {
                                                    e.currentTarget.src = ImageNotAvailableNoCross;
                                                    e.currentTarget.className = "image-not-found";
                                                }} alt='van image' />
                                            </div>
                                        </div>
                                        <div className="van-class-details" role='group'>
                                             <div className="van-class">{selectedVan.vehicleClass}</div>
                                            {/* <div className="van-model">{selectedVan.ymms}</div> */}
                                         </div>
                                     </div>
                                        <div className="van-price-details" role='group'>
                                            {vanCharge && <div className='price-group' aria-label={`${vanCharge.price} dollars and ${vanCharge.decimal} cents`}>
                                                <div className="doller">{'$'}</div>
                                                <div className="price">{numberWithCommas(vanCharge.price)}</div>
                                                <div className="decimal">.{vanCharge.decimal}</div>
                                            </div>}
                                            <div className="sub">{"total per month"}</div>
                                        </div>
                                    </div>

                                }
                                <div className="van-details" role='group'>
                                    <div className="van-class-details" role='group'>
                                        <div className="van-class">{selectedVan.vehicleClass}</div>
                                        {/* <div className="van-model">{selectedVan.ymms}</div> */}
                                    </div>
                                    <div className="van-price-details" role='group'>
                                        {vanCharge && <div className='price-group' aria-label={`${vanCharge.price} dollars and ${vanCharge.decimal} cents`}>
                                            <div className="doller">{'$'}</div>
                                            <div className="price">{numberWithCommas(vanCharge.price)}</div>
                                            <div className="decimal">.{vanCharge.decimal}</div>
                                        </div>}
                                        <div className="sub">{"total per month"}</div>
                                    </div>
                                </div>
                                <RouteDetails vanpool={{ ...selectedVan, originAddress: props.summaryData && props.summaryData.originAddress, destinationAddress: props.summaryData && props.summaryData.destinationAddress }} />
                                <div className="rideDays">
                                    <ul>
                                        {rideDays.length && rideDays.map(day => (<li key={day.substr(0, 3)} aria-label={day}> {day.substr(0, 3)} </li>))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="new-vanpool-summary-plan">
                            <div className="van-datePicker" role='group'>
                                {props.joinCommuteData.plan.noOfDays >= 5 ?
                                    <div className='plan-heading'>Unlimited Plan</div>
                                    :
                                    <div className='plan-heading'>{getPlan(props.joinCommuteData.plan.noOfDays)}-Day Plan</div>
                                }
                                {
                                    !selectedVan.isPredelivery && selectedDay ?
                                        <div className='date-container'>
                                            <label className='sub' aria-label='Your Start Date'>Your Start Date</label>
                                            <label className='date'>{getDayString(selectedDay, true)}</label>
                                        </div>
                                        :
                                        <div className='van-start-details'>
                                            <div className='content'>Your start date will be displayed once the vanpool has formed</div>
                                        </div>
                                }
                            </div>
                        </div>
                        <div className='new-vanpool-payment-details'>
                            <div className='recurring-details' role='group'>
                                <div className='sub-heading'>Auto Recurring Payment</div>
                                {
                                    vanCharge &&
                                    <div className='price-group' aria-label={`${vanCharge.price || '0'} dollars and ${vanCharge.decimal || '00'} cents`}>
                                        <div className="doller">{'$'}</div>
                                        <div className="price">{numberWithCommas(vanCharge.price) || '0'}</div>
                                        <div className="decimal">.{vanCharge.decimal || '00'}</div>
                                    </div>
                                }
                            </div>
                            {
                                ((!showCurrentMonth && !showNextMonth) || selectedVan.isPredelivery  )?
                                    <div className='new-card-list no-next-current' role='group'>
                                        <div className='sub-heading'>
                                            <div>Recurring Payment Card Charges</div>
                                        </div>
                                        <div className='card-list-container'>
                                            {cards &&
                                                cards.map(card => <DisplayCard key={card.cardNumber} card={card} fromFS={true} />)}
                                        </div>
                                    </div> : null
                            }
                        </div>
                        { ((showCurrentMonth || showNextMonth) && !selectedVan.isPredelivery ) ?
                            <div className="new-vanpool-summary-prices" role='group'>
                                {selectedVan.isSubsidized && <div className="final-sponsored-container">
                                    <span>What’s Included?</span>
                                    <SponsoredVanpool />
                                </div>}
                                <RateAccordion
                                    isDesiredDriverRole={isDriver}
                                    charge={vanCharge ? vanCharge.rate : 0}
                                />
                                {props.summaryData && <TaxesAccordion
                                    taxes={props.summaryData.taxes}
                                    surcharges={props.summaryData.surcharges}
                                    total={parseFloat(props.summaryData.taxAmount) + parseFloat(props.summaryData.surchargeAmount)} />}

                                <div className='new-card-list' role='group'>
                                    <div className='sub-heading'>
                                        <div>Recurring Payment Card Charges</div>
                                    </div>
                                    <div className='card-list-container'>
                                        {cards &&
                                            cards.map(card => <DisplayCard key={card.cardNumber} card={card} fromFS={true} />)}
                                    </div>
                                </div>
                                <div className='bottom' role='group'>
                                    <div className='disclaimer' role='group'>
                                        <p>
                                            Recurring subscription. <br />
                                            Rates subject to change. <br />
                                            <span onClick={() => updatePDPopup(true)}>Learn More</span>
                                        </p>
                                    </div>
                                    <div className='total'>
                                        <div className='label'>Total</div>
                                        {vanCharge && <span className='grp'>
                                            <div className='price' aria-label={`${vanCharge.price} dollars and ${vanCharge.decimal} cents`}>
                                                <div className='dollar'>$</div>
                                                <div>{numberWithCommas(vanCharge.price)}</div>
                                                <div className='dollar'>.{vanCharge.decimal}</div>
                                            </div>
                                            <div className='frequency'>per month</div>
                                        </span>}
                                    </div>
                                </div>
                            </div> : null
                        }

                    </div>
                    <div className='right-column'>

                        <div className="new-vanpool-summary-image">
                            <div className="van-Image">
                                <div className={`${selectedVan.isPredelivery ? 'car-image-opacity' : 'car-image'}`}>
                                    <img src={selectedVan.carClassImage} onError={e => {
                                        e.currentTarget.src = ImageNotAvailableNoCross;
                                        e.currentTarget.className = "image-not-found";
                                    }} alt='van image' />
                                </div>
                            </div>
                        </div>

                        {((!showCurrentMonth && !showNextMonth) || selectedVan.isPredelivery ) ?
                            <div className="new-vanpool-summary-prices" role='group'>
                                {selectedVan.isSubsidized && <div className="final-sponsored-container">
                                    <span>What’s Included?</span>
                                    <SponsoredVanpool />
                                </div>}
                                <RateAccordion
                                    isDesiredDriverRole={isDriver}
                                    charge={vanCharge ? vanCharge.rate : 0}
                                />
                                {props.summaryData && <TaxesAccordion
                                    taxes={props.summaryData.taxes}
                                    surcharges={props.summaryData.surcharges}
                                    total={parseFloat(props.summaryData.taxAmount) + parseFloat(props.summaryData.surchargeAmount)} />}

                                <div className='bottom' role='group'>
                                    <div className='disclaimer' role='group'>
                                        <p>
                                            Recurring subscription. <br />
                                            Rates subject to change. <br />
                                            <span onClick={() => updatePDPopup(true)}>Learn More</span>
                                        </p>
                                    </div>
                                    <div className='total'>
                                        <div className='label'>Total</div>
                                        {vanCharge && <span className='grp'>
                                            <div className='price' aria-label={`${vanCharge.price} dollars and ${vanCharge.decimal} cents`}>
                                                <div className='dollar'>$</div>
                                                <div>{numberWithCommas(vanCharge.price)}</div>
                                                <div className='dollar'>.{vanCharge.decimal}</div>
                                            </div>
                                            <div className='frequency'>per month</div>
                                        </span>}
                                    </div>
                                </div>
                            </div> : null
                        }

                        {
                            ((showCurrentMonth || showNextMonth ) && !selectedVan.isPredelivery )  ?
                                //new section for current and next month
                                <div className='current-next-month-charges'>
                                    <div className='cn-heading-main pay-today'>
                                        <div className='cn-header'>
                                            <div className='label'>You Pay Today</div>
                                            {!selectedVan.isPredelivery && selectedDay ?
                                                (proratedAmount &&
                                                    <div className='price-group' aria-label={`${proratedAmount.price || '0'} dollars and ${proratedAmount.decimal || '00'} cents`}>
                                                        <div className="doller">{'$'}</div>
                                                        <div className="price">{numberWithCommas(proratedAmount.price) || '0'}</div>
                                                        <div className="decimal">.{proratedAmount.decimal || '00'}</div>
                                                    </div>)
                                                :
                                                <div className='price-group'>
                                                    <div className="doller">{'$'}</div>
                                                    <div className="price">{'0'}</div>
                                                    <div className="decimal">.{'00'}</div>
                                                </div>}
                                        </div>
                                        <div className='cn-content'>
                                            {
                                               (showCurrentMonth && showNextMonth) ?
                                               "Today’s payment includes your pro-rated amount for the current period and next month’s full payment" :
                                               showCurrentMonth ? 
                                               "Today's payment includes your pro-rated amount for the current period" :
                                               showNextMonth ?
                                               "Today's payment includes your next month's full payment" :
                                               null
                                            }
                                          
                                        </div>
                                    </div>
                                    {showCurrentMonth ?
                                        <>
                                            <div className='cn-heading-main current-month'>
                                                <div className='cn-header'>
                                                    <div className='label pro-rated'> Pro-rated Amount</div>
                                                    {!selectedVan.isPredelivery && selectedDay ?
                                                        (currentTotalAmount &&
                                                            <div className='price-group' aria-label={`${currentTotalAmount.price || '0'} dollars and ${currentTotalAmount.decimal || '00'} cents`}>
                                                                <div className="doller">{'$'}</div>
                                                                <div className="price">{numberWithCommas(currentTotalAmount.price) || '0'}</div>
                                                                <div className="decimal">.{currentTotalAmount.decimal || '00'}</div>
                                                            </div>)
                                                        :
                                                        <div className='price-group'>
                                                            <div className="doller">{'$'}</div>
                                                            <div className="price">{'0'}</div>
                                                            <div className="decimal">.{'00'}</div>
                                                        </div>}
                                                </div>
                                                <div className='cn-content'>Your prorated amount is for your start date through the end of this month.</div>
                                            </div>
                                            <RateAccordion isDesiredDriverRole={isDriver} charge={currentTotalAmount ? currentTotalAmount.rate : 0} />
                                            {currentMonthProratedDetail && (currentMonthProratedDetail.proratedTaxes || currentMonthProratedDetail.proratedSurcharges) && <TaxesAccordion
                                                taxes={currentMonthProratedDetail.proratedTaxes}
                                                surcharges={currentMonthProratedDetail.proratedSurcharges}
                                                total={ getTaxesSurchargesTotal(currentMonthProratedDetail.proratedTaxes,currentMonthProratedDetail.proratedSurcharges)}
                                            />}

                                        </> : null
                                    }

                                    {showNextMonth ?
                                        <>
                                            {/* next month details */}
                                            <div className='cn-heading-main next-month'>
                                                <div className='cn-header'>
                                                    <div className='label'>Next Month's Payment</div>
                                                    {nextTotalAmount ?
                                                        <div className='price-group' aria-label={`${nextTotalAmount.price || '0'} dollars and ${nextTotalAmount.decimal || '00'} cents`}>
                                                            <div className="doller">{'$'}</div>
                                                            <div className="price">{numberWithCommas(nextTotalAmount.price) || '0'}</div>
                                                            <div className="decimal">.{nextTotalAmount.decimal || '00'}</div>
                                                        </div>
                                                        :
                                                        <div className='price-group'>
                                                            <div className="doller">{'$'}</div>
                                                            <div className="price">{'0'}</div>
                                                            <div className="decimal">.{'00'}</div>
                                                        </div>
                                                    }
                                                </div>
                                                {/* <div className='cn-content'>Your prorated amount is for your start date through the end of this month. </div> */}
                                            </div>
                                            <RateAccordion isDesiredDriverRole={isDriver} charge={nextTotalAmount ? nextTotalAmount.rate : 0} />
                                            {nextMonthProratedDetail && (nextMonthProratedDetail.proratedTaxes || nextMonthProratedDetail.proratedSurcharges) && <TaxesAccordion
                                                taxes={nextMonthProratedDetail.proratedTaxes}
                                                surcharges={nextMonthProratedDetail.proratedSurcharges}
                                                total={getTaxesSurchargesTotal(nextMonthProratedDetail.proratedTaxes,nextMonthProratedDetail.proratedSurcharges)}
                                            />}
                                        </> : null
                                    }

                                    {
                                         (showCurrentMonth || showNextMonth) ?

                                        <div className='new-card-list' role='group'>
                                                <div className='sub-heading'>
                                                    <div>Payment Card Charges</div>
                                                </div>
                                                <div className='card-list-container'>
                                                    {getPaymentCards()}
                                                </div>
                                        </div> : null

                                    }
                                    {/* this is for both current and next */}
                                    <div className='bottom' role='group'>
                                        <div className='disclaimer' role='group'>
                                            <p>
                                                Rates subject to change. <br />
                                                <span onClick={() => updatePDPopup(true)}>Learn More</span>
                                            </p>
                                        </div>
                                        <div className='total'>
                                            <div className='label'>Total</div>
                                            {proratedAmount && <span className='grp'>
                                                <div className='price' aria-label={`${proratedAmount.price} dollars and ${proratedAmount.decimal} cents`}>
                                                    <div className='dollar'>$</div>
                                                    <div>{numberWithCommas(proratedAmount.price)}</div>
                                                    <div className='dollar'>.{proratedAmount.decimal}</div>
                                                </div>
                                                {/* <div className='frequency'>per month</div> */}
                                            </span>}
                                        </div>
                                    </div>

                                </div> : null
                        }

                    </div>




                </div>
                {
                    showPDPopup && <PriceDisclaimerPopup updatePDPopup={() => updatePDPopup(false)} />
                }
                <div className='bottom-section'>
                    <div className='condition' role='group'>
                        {checkBox ?
                            <div className='checkbox selected' aria-labelledby="condition" aria-checked='true' onClick={toggleCheckBox} onKeyDown={(e) => onCheckKeyDown(e)} role='checkbox' tabIndex={0}>
                                <img src={Tick} aria-hidden='true' />
                            </div>
                            :
                            <div className='checkbox' aria-checked='false' aria-labelledby="condition" onClick={toggleCheckBox} onKeyDown={(e) => onCheckKeyDown(e)} role='checkbox' tabIndex={0}></div>
                        }
                        <div className='text' id="condition" aria-hidden='true'>
                            I agree to be enrolled in a recurring monthly subscription for the total amount above, subject to change. I understand I will be charged the prorated amount today for the first month, and thereafter, the monthly rate on the fifth day of each month until cancelled. Federal benefit cards will be charged each month according to its payment schedule. Commuter benefit cards will be charged on the second day of each month. I understand I may cancel with 30 days’ notice online or by telephone at <Callable phone="800 VAN 4 WORK" />.
                        </div>
                    </div>
                    <div className='button-container'>
                        <button className='continue-button' onClick={onContinue} disabled={buttonDisabled}>CONTINUE</button>
                    </div>
                </div>
            </div>

        </div>
    );
}

function mapStateToProps(state) {
    return {
        joinCommuteData: state.joinCommute,
        summaryData: state.joinCommute.userCommuteData && state.joinCommute.userCommuteData.summaryData,
        isCardLoading: state.joinCommute.payment.isCardSaving,
        isLoadingProratedAmount: state.joinCommute.payment.isLoadingProratedAmount,
        isSaving: state.joinCommute.payment.isSavingSubscription,
        isChangedPlan: state.joinCommute.drivingScheduleData.isChangedPlan
    }
}
function mapDispatchToProps(dispatch) {
    return {
        getProratedAmount(startDate, history) {
            dispatch({
                type: GET_PRORATED_AMOUNT,
                startDate,
                history
            })
        },
        getDocusignContract(isDriver, vanpoolId, history) {
            dispatch({ type: APPLY_TO_SIGN_CONTRACT, data: { isDriver: isDriver, vanpoolId: vanpoolId, history } })
        },
        saveSummary(startDate, history) {
            dispatch({
                type: SAVE_SUBSCRIPTION_SUMMARY,
                startDate,
                history
            })
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(FinalSummary)